import { getResellerLandingsData } from '../../redux/landings/landings.actions';
export const getGamification = () => undefined;
export const handleLoginFailed = () => undefined;
export const fetchInitialStatesOther = () => undefined;
export const getCheckoutTenantData = dispatch => {
  dispatch(getResellerLandingsData());
};